import { EAccountSubscriptionPlans, IRetrieveSubscriptionPricesRespDto } from 'src/types'

export function countPrice(
  months: number,
  subscription_plan: EAccountSubscriptionPlans,
  prices?: IRetrieveSubscriptionPricesRespDto | void,
): null | { amount: string; frequency: string } {
  if (!prices) return null

  switch (subscription_plan) {
    case EAccountSubscriptionPlans.plus:
      if (months === 1) return { amount: prices.plusMonthly, frequency: 'subscription-month-text.v' }
      return { amount: prices.plusYearly, frequency: 'subscription-year-text.v' }
    case EAccountSubscriptionPlans.premium:
      if (months === 1)
        return { amount: prices.premiumMonthly, frequency: 'subscription-month-text.v' }
      return { amount: prices.premiumYearly, frequency: 'subscription-year-text.v' }
    default:
      return null
  }
}
